<template>
    <div>
        <div style="text-align: right;">
            <el-input v-model="keyword" size="mini" style="width:40%;" placeholder="搜索"></el-input>
        </div>
        <el-table ref="multipleTable"
            :data="tableData"
            row-key="deviceId"
            @selection-change="selectRow">
            <el-table-column type="selection" width="55"
                :reserve-selection="true"
                :selectable="selectableHandle"> </el-table-column>
            <el-table-column align="center" prop="name" label="名称"></el-table-column>
            <el-table-column align="center" prop="area" label="设备所在地"></el-table-column>
            <el-table-column align="center" prop="room" label="所属机房"></el-table-column>
            <!-- <el-table-column align="center" prop="room" label="容器类型" width="160px"
                v-if="!serviceMode"
            >
                <template v-slot="{row}">
                    <el-select v-model="row.containerType"
                        placeholder="容器类型"
                        @change="chooseContainerType(row)">
                        <el-option v-for="(option, index) in containerTypes"
                            :key="index"
                            :value="option.type"
                            :label="option.type">
                        </el-option>
                    </el-select>
                </template>
            </el-table-column> -->
            <el-table-column v-if="!serviceMode" align="center" prop="room" label="容器实例" width="160px">
                <template v-slot="{row}">
                    <el-select
                        v-model="row.containerId"
                        placeholder="容器实例">
                        <el-option v-for="(option, index) in row.containerInstanceList"
                            :key="index"
                            :value="option.id"
                        >
                            <span style="float: left">{{ '实例'+option.id }}</span>
                            <span style="float: right; color: #8492a6; font-size: 13px">
                                {{ option.alias }}
                            </span>
                        </el-option>
                    </el-select>
                </template>
            </el-table-column>
            <el-table-column align="center" prop="room" label="状态" width="100px">
                <template v-slot="{row}">
                    <i
                        class="el-icon-success"
                        title="复制成功"
                        style="color:#67C23A;"
                        v-if="copySuccess(row.deviceId)"
                    ></i>
                    <i
                        class="el-icon-error"
                        title="复制失败"
                        style="color:#F56C6C;"
                        v-if="copyFail(row.deviceId)"
                    ></i>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination
            class="fy"
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[10,20,30,40]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalElement"
        ></el-pagination>
    </div>
</template>
<script>
export default {
    props: {
        serviceMode: {
            type: Boolean,
        },
        containerType: {
            type: String
        },
        copyFailed: {
            type: Array,
            default: ()=>{
                return []
            }
        },
        copies: {
            type: Array,
            default: ()=>{
                return []
            }
        },
        deviceId: {
            type: [Number, String]
        }
    },
    data: vm=>({
        dataList: [],
        selects: [],
        currentPage: 1,
        pageSize: 10,
        keyword: '',
        totalElement: 0,
        containerInstanceList: [],
        oldSelects: []
    }),
    computed: {
        tableData(){
            let datas = []
            if(this.keyword){
                datas = this.filterArr(this.keyword, this.dataList)
            }else{
                datas = this.dataList
            }
            this.totalElement = datas.length
            let start = (this.currentPage - 1) * this.pageSize
            let end = this.currentPage * this.pageSize
            let arr = datas.slice(start, end)
            return arr
        },
        copySuccess(){
            return (deviceId)=>{
                const inSelects = this.oldSelects.findIndex(select => select.deviceId == deviceId) != -1
                const notInFailed = this.copyFailed.findIndex(failRow => failRow.id == deviceId) == -1
                const inCopies = this.copies ? this.copies.findIndex(copy => copy.deviceId == deviceId) != -1 : false
                return inSelects && notInFailed || inCopies
            }
        },
        copyFail(){
            return (deviceId) => {
                return this.copyFailed.findIndex(failRow => failRow.id == deviceId) != -1
            }
        },
    },
    created(){
        this.findAll()
    },
    methods: {
        handleSizeChange(val){
            this.pageSize = val
        },
        handleCurrentChange(val){
            this.currentPage = val
        },
        findAll() {
            this.$axios.get(this.baseUrl3 + "management3/device/findAll")
            .then(({ data: { msg, data, code } }) => {
                if(code == 20000){
                    const _this = this
                    data.forEach((dataItem, index)=>{
                        dataItem.deviceId = dataItem.id
                        dataItem.id = ''
                        dataItem.containerId = ''
                        dataItem.containerType = _this.containerType
                        dataItem.containerInstanceList = []
                        _this.chooseContainerType(dataItem, index)
                    })
                    this.dataList = data
                }else{
                    this.$message({ showClose: true, message: msg, type: "error" });
                    console.log(msg);
                }
            });
        },
        selectRow(val){
            this.selects = val
        },
        chooseContainerType(row, index){
            this.containerInstanceList = []

            this.$axios.get(this.baseUrl3 + 'instance/findAllByDeviceAndModuleType/' + row.deviceId
            + '/' + row.containerType)
            .then(({data:{code, data, msg}}) => {
                if(code != 20000){
                    this.$message.error('查找模块的实例列表失败：'+msg)
                }else{
                    // this.containerInstanceList = data
                    // row.containerInstanceList = data
                    this.dataList[index].containerInstanceList = data
                }
            })
            .catch(err => {
                console.log(err)
            })
        },
        setOldSelects(){
            this.oldSelects = [...this.selects]
        },
        selectableHandle(row, index){
           const idx = this.copies ? this.copies.findIndex(copy => copy.deviceId == row.deviceId) : -1
           if(idx != -1 || row.deviceId == this.deviceId){
               return false
           }else{
               return true
           }
        }
    }
}
</script>
